import { MenuItem } from "@mui/material"

export function LanguageOption({ item }) {
    return (
        <MenuItem value={item.code}>
            {item.name} ({item.nativeName || item.code})
        </MenuItem>
    )
}
